var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 41,
    viewBox: "0 0 49 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9976 4.86715C47.1624 5.70255 45.2163 6.25119 43.2236 6.49493C45.3239 5.20219 46.8959 3.16766 47.6466 0.770476C45.6755 1.97771 43.5144 2.82376 41.262 3.28142C39.7491 1.61549 37.7437 0.510632 35.5576 0.138621C33.3715 -0.233391 31.1273 0.148284 29.1737 1.22431C27.2202 2.30033 25.6668 4.01042 24.7551 6.08871C23.8434 8.167 23.6244 10.4971 24.1322 12.7166C20.1349 12.5104 16.2244 11.4414 12.6545 9.57897C9.08472 7.71652 5.9354 5.10228 3.41106 1.90597C2.51752 3.48539 2.04797 5.28084 2.05048 7.10844C2.05048 10.6955 3.82452 13.8645 6.52163 15.7199C4.9255 15.6682 3.3645 15.2246 1.96875 14.426V14.5547C1.96923 16.9437 2.77252 19.259 4.24242 21.108C5.71232 22.9571 7.75837 24.2261 10.0337 24.6999C8.55196 25.1131 6.99833 25.174 5.49038 24.878C6.13189 26.9343 7.38223 28.7327 9.06633 30.0214C10.7504 31.31 12.784 32.0244 14.8822 32.0645C12.7968 33.75 10.4091 34.9959 7.85548 35.7311C5.30188 36.4663 2.63252 36.6764 0 36.3492C4.59543 39.3906 9.94494 41.0052 15.4087 41C33.9014 41 44.0144 25.2342 44.0144 11.5613C44.0144 11.1161 44.0024 10.6658 43.9832 10.2255C45.9516 8.76138 47.6505 6.94769 49 4.86962L48.9976 4.86715Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwitter);
export default __webpack_public_path__ + "static/media/FooterTwitter.5cd55642efeb6b2337da67010fbcaeea.svg";
export { ForwardRef as ReactComponent };